import { isNil } from 'lodash'

const MAX_WEIGHT = 1

const parsePonderation = options => {
    try {
        return JSON.parse(options)?.ponderation ?? undefined
    } catch {
        return undefined
    }
}

const buildOptions = ponderation => isNil(ponderation) ? undefined : JSON.stringify({ ponderation })

const getAppliedWeights = (codes, weights) => {
    const declaredTotal = codes.reduce((acc, code) => acc + (weights[code] ?? 0), 0)
    const undeclared = codes.filter(code => isNil(weights[code]))
    const share = undeclared.length ? Math.max(0, MAX_WEIGHT - declaredTotal) / undeclared.length : 0
    return codes.reduce((acc, code) => ({ ...acc, [code]: weights[code] ?? share }), {})
}

export { MAX_WEIGHT, parsePonderation, buildOptions, getAppliedWeights }